<template>
  <FormSelectMultipleGroup
    v-if="temasQuestoes"
    :label="label"
    :value="value"
    :grupoConteudoId="grupoConteudoId"
    :options="temasQuestoes"
    :max="max"
    :placeholder="placeholder"
    :name="name"
    :groupSelect="groupSelect"
    selectedLabel="Selecionado"
    :scope="scope"
    groupValues="subTemas"
    groupLabel="text"
    @input="$emit('input', $event)"
    @change="$emit('input', $event)"
  />
</template>

<script>
import FormSelectMultipleGroup from "~/components/UIComponents/Forms/FormSelectMultipleGroup";
import TemaService from "~/domain/prova/TemaService";

export default {
  name: "form-select-multiple-group-tema",
  components: {
    FormSelectMultipleGroup
  },
  props: {
    label: {
      type: String,
      default: "Tema"
    },
    id: String,
    name: String,
    scope: String,
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    required: String,
    value: Array,
    groupValues: String,
    groupLabel: String,
    groupSelect: {
      type: Boolean,
      default: true
    },
    max: Number,
    grupoConteudoId: Number,
    temasResult: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      active: false,
      messages: {
        noOptions: "Nenhuma opção disponível"
      },
      temaQuestao: [],
      temaService: new TemaService(this.$http)
    };
  },
  mounted() {
    this.$el.value = this.value;
  },
  methods: {
    changeFocus() {
      this.active = !this.active;
    }
  },
  asyncComputed: {
    temasQuestoes() {
      let temasQuestoes = [];

      let temasSemSubtemas = {
        value: 0,
        text: "Outros",
        subTemas: []
      };

      this.temasResult.map(tema => {
        if (!tema.temaId) {
          let subTemas = [];

          this.temasResult.map(subTema => {
            if (subTema.temaId === tema.id) {
              subTemas.push({
                value: subTema.id,
                text: subTema.nome
              });
            }
          });

          if (subTemas.length > 0) {
            temasQuestoes.push({
              value: tema.id,
              text: tema.nome,
              subTemas
            });
          } else {
            temasSemSubtemas.subTemas.push({
              value: tema.id,
              text: tema.nome
            });
          }
        }
      });

      if (temasSemSubtemas.subTemas.length > 0) {
        temasQuestoes.push(temasSemSubtemas);
      }

      return temasQuestoes;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/FormSelectMultipleGroupTema.vue